import React, { Component } from 'react';
import TournamentDetailHome from "./TournamentDetailHome";
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import TournamentDetailDesc from "./TournamentDetailDesc";
import { FiAward, FiClipboard, FiHome } from 'react-icons/fi';
import TournamentDetailLeaderboard from "./TournamentDetailLeaderboard";
import { API_BASE_URL } from "../../constatns";
import ReactGA from "react-ga";

class TournamentDetail extends Component {

	constructor(props) {
		super(props);
		this.state = {
			activeTab: 1,
			result: null
		};
		this.onChangeMenu = this.onChangeMenu.bind(this);

		fetch(`${API_BASE_URL}/tournament/info?tournamentId=${this.props.match.params.id}`, {
			method: 'GET',
		}).then(res => res.text())
		.then(body => {
			let _result = JSON.parse(body);
			this.setState({result: _result});
		});
	}

	componentDidMount() {
	}

	onChangeMenu(m) {
		this.setState({activeMenu: m});
	}

	setActiveTab(idx) {
		this.setState({activeTab: idx});
	}

	render() {

		ReactGA.pageview(window.location.pathname + window.location.search);
		return (
			<main className={'tournament-page'}>
				{ this.state.result ?
					<div>
				<div className="tournament-detail-banner">
					<div className="title">{this.state.result.title}</div>
					<div className="info market-tabs p-0">
						<Nav tabs className="tabs-scoial borderb-tab-primary market-tabs">
							<NavItem className="nav nav-tabs" >
								<NavLink className={this.state.activeTab === '1' ? 'active  p-10' : ''} onClick={() => this.setActiveTab('1')} >
									<span style={{padding: '20px'}} ><FiHome></FiHome> Home</span>
								</NavLink>
							</NavItem>
							<NavItem className="nav nav-tabs " >
								<NavLink className={this.state.activeTab === '2' ? 'active' : ''} onClick={() => this.setActiveTab('2')}>
									<FiAward></FiAward> LeaderBoard
								</NavLink>
							</NavItem>
							{/*<li className="nav-item">*/}
							{/*	<div className="user-designation"></div>*/}
							{/*	<div className="desc mb-15">&nbsp;</div>*/}
							{/*	<FaCrown></FaCrown> {this.state.result.owner[0].username}*/}
							{/*</li>*/}
							{/*<NavItem className="nav nav-tabs" >*/}
							{/*	<NavLink className={this.state.activeTab === '3' ? 'active' : ''} onClick={() => this.setActiveTab('3')}>*/}
							{/*		<FiUsers></FiUsers> Participants*/}
							{/*	</NavLink>*/}
							{/*</NavItem>*/}
							<NavItem className="nav nav-tabs" >
								<NavLink className={this.state.activeTab === '4' ? 'active' : ''} onClick={() => this.setActiveTab('4')}>
									<FiClipboard></FiClipboard> Description
								</NavLink>
							</NavItem>
						</Nav>
					</div>
				</div>

				<div className="main-body section-gap tournament-main">
					<div className="container">
						<div className="row">

							<TabContent activeTab={this.state.activeTab} className="tab-content">
								<TabPane tabId="1" className={this.state.activeTab === 1 ? 'active' : ''}>
									<TournamentDetailHome data={this.state.result}/>
								</TabPane>
								<TabPane tabId="2" className={this.state.activeTab === 2 ? 'active' : ''}>
									<TournamentDetailLeaderboard data={this.state.result}/>
								</TabPane>
								{/*<TabPane tabId="3" className={this.state.activeTab === 3 ? 'active' : ''}>*/}
								{/*	<TournamentDetailParticipants data={this.state.result}/>*/}
								{/*</TabPane>*/}
								<TabPane tabId="4" className={this.state.activeTab === 4 ? 'active' : ''}>
									<TournamentDetailDesc data={this.state.result}/>
								</TabPane>
							</TabContent>
						</div>
					</div>
				</div>
					</div>
					: ''}
			</main>
		);
	}
}

export default TournamentDetail;
